import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';
import Field from '../Field/Field';

const ViewFieldset: FC<
  PropsWithChildren<{
    className?: string;
  }>
> = (props) => {
  const { className, children } = props;

  return (
    <div
      className={clstx(
        'typography:prose grid grid-cols-1 items-end',
        className
      )}
    >
      {children}
    </div>
  );
};

const ViewField: FC<
  PropsWithChildren<{
    className?: string;
    label: string;
    description?: string;
  }>
> = (props) => {
  const { className, label, children, description } = props;

  return (
    <div
      className={clstx(
        'block border-gray-200 [&:nth-last-child(n+2)]:border-b [&:nth-last-child(n+2)]:pb-3',
        className
      )}
    >
      <Field.Label className="mt-3">{label}</Field.Label>
      <p className="mt-2 break-words">{children}</p>
      {description && (
        <p className="text-gray-500 supporting-body mt-2">{description}</p>
      )}
    </div>
  );
};

export default Object.assign(ViewFieldset, {
  Field: ViewField,
});
